import moment from 'moment';
import CommonStore from '../stores/CommonStore';

export function parseQueryParam(uriString) {
  const urlParams = new URLSearchParams(uriString);
  const params = Object.fromEntries(urlParams);
  return params;
}

export function formatMoney(amount, decimalCount = 0, decimal = ',', thousands = '.') {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? '-' : '';

    let i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))).toString();
    let j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
      (decimalCount
        ? decimal +
          Math.abs(amount - i)
            .toFixed(decimalCount)
            .slice(2)
        : '')
    );
  } catch (e) {
    console.error(e);
  }
}

export function formatDate(timeMillis, dateFormat = 'DD MMM YYYY, HH:mm:ss') {
  const date = new Date(timeMillis);
  const formatedDate = moment(date).format(dateFormat);
  return formatedDate;
}

export function isEmptyObject(obj) {
  if (!obj) return true;
  return Object.entries(obj).length === 0 && obj.constructor === Object;
}

export function onlyNumbers(e) {
  e.target.value = e.target.value.replace(/[^0-9]/g, '');
}

export function formatPhoneNumber(phoneNumber) {
  if (phoneNumber && phoneNumber !== '') {
    if (phoneNumber.substring(0, 2) === '62') return '+62' + phoneNumber.slice(2, phoneNumber.length);
    else if (phoneNumber.substring(0, 1) === '0') return '+62' + phoneNumber.slice(1, phoneNumber.length);
    else return '+62' + phoneNumber;
  } else if (phoneNumber !== '') return '+62' + phoneNumber;
  else return '';
}

export function createDataUrl(element) {
  try {
    var s = new XMLSerializer().serializeToString(element);
    return 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(s)));
  } catch (e) {
    console.error(e);
  }
}

export function formatBankAccount(string = '') {
  try {
    const chunks = string.match(/.{1,4}/g);
    const joined = chunks.join('-');
    return joined;
  } catch (e) {
    console.error(e);
  }
}

export function copyToClipboard(string) {
  const el = document.createElement('textarea');
  el.value = string;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
  el.select();
  document.execCommand('copy');
  CommonStore.showSuccessMessage(`${string} tersalin!`);
  document.body.removeChild(el);
  if (selected) {
    document.getSelection().removeAllRanges();
    document.getSelection().addRange(selected);
  }
}
export function resizeBase64Image(img, width, height) {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  canvas.width = width;
  canvas.height = height;

  ctx.drawImage(img, 0, 0, width, height);
  return canvas.toDataURL('image/png', 1);
}

export const checkCameraPermission = () => {
  if (window.location.protocol !== 'https:') {
    navigator.getUserMedia =
      navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
    if (navigator.getUserMedia) {
      navigator.getUserMedia(
        { audio: true, video: true },
        function(stream) {
          document.querySelector('video').src = stream;
          const mediaStreamTrack = stream.getVideoTracks()[0];
          if (typeof mediaStreamTrack != 'undefined') {
            mediaStreamTrack.onended = function() {
              //for Chrome.
              CommonStore.showErrorMessage('Your camera is busy!');
            };
          } else CommonStore.showErrorMessage('Camera permission denied!');
        },
        function(e) {
          let message = '';
          switch (e.name) {
            case 'NotFoundError':
            case 'DevicesNotFoundError':
              message = 'Please setup your camera first.';
              break;
            case 'SourceUnavailableError':
              message = 'Your camera is busy';
              break;
            case 'PermissionDeniedError':
            case 'SecurityError':
              message = 'Camera Permission denied!';
              break;
            default:
              message = 'Camera Permission denied!';
              break;
          }
          CommonStore.showErrorMessage(message);
        },
      );
    } else return 'Uncompatible browser!';
  } else return 'Use https protocol for open this page.';
};

export const parseJwt = token => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );

  return JSON.parse(jsonPayload);
};
